import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    height: "calc(100vh - 100px)",
    width: "100%",
    overflowX: "auto",
    padding: theme.spacing(2),
    boxSizing: "border-box",
  },
  header: {
    width: "98%",
    background: "#f0f0f0",
    padding: "1%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    color: theme.palette.secondary.main,
    letterSpacing: "0.1rem",
    fontWeight: 600,
    fontSize: "120%",
  },
  contractStatus: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  contractStatusLabel: {
    fontSize: "60%",
    position: "absolute",
    top: "20px",
  },
  contractStatusValue: {
    fontWeight: "500",
    color: "#1f6e5e",
  },
  resetContractButton: {
    fontSize: "0.75em",
    backgroundColor: "orangered",
    color: "#ffffff",
    borderRadius: "0",
    "&:hover": {
      border: "1px solid orangered",
      backgroundColor: "#ffffff",
      color: "orangered",
    },
  },
  sectionSeparator: {
    width: "100%",
    height: "0.3rem",
    background: "transparent",
  },
  detailSectionPane: {
    display: "flex",
    padding: "1%",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#fff",
  },
  detailSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "35%",
  },
  sectionDataElement: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "1rem",
  },
  sectionDataElementLabel: {
    width: "40%",
  },
  sectionDataElementValue: {
    width: "60%",
  },
  spanText: {
    ...theme.typography.subtitle1,
  },
  gridRoot: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {},
  img: {
    objectFit: "cover",
    objectPosition: "center",
    width: "100%",
    height: "100%",
  },
  button: {
    fontSize: "0.75em",
    backgroundColor: "#1e453b",
    color: "#ffffff",
    borderRadius: "0",
    "&:hover": {
      border: "1px solid #1e453b",
      backgroundColor: "#ffffff",
      color: "#1e453b",
    },
  },
  navigationPanel: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    paddingRight: "1%",
  },
  linkSection: {
    background: "#fff",
    display: "flex",
    padding: "1%",
  },
  tabPanel: {
    flexBasis: "82%",
  },
  tab: {
    backgroundColor: "#fff", //"#f3efe6", //"#1f6e5e",
  },
  tabLogos: {
    width: "35px",
    height: "30px",
  },

  brandContainer: {
    padding: "15px",
    paddingTop : "5px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  formSectionTitle: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
    fontSize: "18px",
    fontWeight: "600",
    borderBottom: "1px solid #f0f0f0",
    marginBottom: "10px",
    color: "#1f6e5e",
    lineHeight: 1,
    letterSpacing: 0,
  },
  brandSection: {
    display: "flex",
    justifyContent: "space-between",
    padding : "1%",
    paddingTop : 0
  },
  brandPeopleSection: {
    display: "flex",
    flexDirection: "column",
    width: "45%",
  },
  text_container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginBottom : "10px",
    marginTop : "10px",
  },
  text_container_label: {
    width: "20%",
    padding: "1%",
  },
  brandRevenues: {
    display: "flex",
    flexDirection: "column",
    width: "25%",
  },
  inputRevenue: {
    textAlign: "right !important",
  },
  inlineErrorMessage : {
    display: "flex",
    color: "red",
    justifyContent: "center"
  },
  brandActions : {
    '& > *': {
      margin: theme.spacing(1)
  },
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: '#fff',
  justifyContent: 'center',
  }
}));
